<template>
  <qx-card-form title="结算信息">
    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="120px"
    />
  </qx-card-form>
</template>

<script>
export default {
  data () {
    return {
      baseForm: {
        form: [
          {
            label: '原因',
            value: 'loanTransReason',
            type: 'select',
            options: [
              {
                label: '因公',
                value: 1,
              },
              {
                label: '因私',
                value: 2,
              },
            ],
            hide: true,
          },
          {
            label: '说明',
            value: 'remark',
            type: 'input',
            attr: {
              type: 'textarea',
            },
          },
        ],
        rules: {
          loanTransReason: [
            { required: true, message: '请选择原因', trigger: 'blur' },
          ],
          remark: [
            { required: true, message: '请输入说明', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    receiveData (tar, val) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: val.loanSubject !== '5',
        names: ['loanTransReason'],
      });
    },
    async cacheData () {
      let res = await this.$refs.baseForm.getVal();
      return res;
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
    init (data = {}) {
      this.$refs.baseForm.setVal('form', data);
    },
  },
};
</script>

<style scoped lang="scss">
</style>
